<div class="widget-container" #EventDUCalender>
<app-event-schedule ></app-event-schedule>
</div>